import {http} from '@/utils/http'
import {AxiosResponse} from "axios";
import {INewShift, IShift} from "@/features/shifts/shifts.types";

export const shiftService = {
    getShifts(isActive?: boolean): Promise<AxiosResponse> {
        if (isActive !== undefined) {
            return http.get<IShift[]>(`/shifts?active=${isActive}`)
        } else {
            return http.get<IShift[]>('/shifts')
        }
    },

    createShift(payload: INewShift): Promise<AxiosResponse> {
        return http.post('/shifts', payload)
    },

    getShiftById(shiftId: string): Promise<AxiosResponse> {
        return http.get<IShift>(`/shifts/${shiftId}`)
    },

    updateShift(shiftId: string, payload: INewShift): Promise<AxiosResponse> {
        return http.put(`/shifts/${shiftId}`, payload)
    },

    deleteShift(shiftId: string): Promise<AxiosResponse> {
        return http.delete(`/shifts/${shiftId}`)
    }

}